// export default "https://ws.etclite.com/sdx/ws"
// export default "https://localhost:8111/sdx"
// export default "https://ws.smpldocs.com/sdx"
// export default "https://ws.smpldocs.com/sdx"
export default "https://dev.ws.smpldocs.com/sdx"